import React from 'react';
import { Link } from 'react-router-dom';
import Img from '../../../../components/Img';
import { LeagueGenderValues } from '../../../../utils/eventConstants';
import styles from './CollegeCornerCollegeRankings.scss';

import { defaultConferenceColumn, defaultDivisionColumn, defaultP6Column, defaultRankingColumn, defaultTableFilters, defaultRecordColumn } from '../helpers';

export const customText = 'There are no results that meet this criteria.';

export const initialCustomOptions = {
    division: [],
    snapshotDates: [],
    gender: [
        { label: `Male`, value: LeagueGenderValues.MALE },
        { label: `Female`, value: LeagueGenderValues.FEMALE },
    ],
};

export const initialTableFilters = {
    ...defaultTableFilters,
    order: 'desc',
    sort: 'rank',
};

const power6Generic = {
    ...defaultP6Column,
    sortable: false,
};

export const initialFilters = {
    ...initialTableFilters,
    gender: 'M',
    conference: null,
    division: null,
    snapshotDate: null,
    locationInputValue: '',
    locationCountryName: '',
    locationStateName: '',
    distance: '50mi',
    location: '',
    lat: null,
    lng: null,
};

export const columns = [
    {
        ...defaultRankingColumn,
        headerClassName: `${styles.rankingHead}`,
        rowClassName: `${styles.rankingCol}`,
        key: 'rank',
        custom: (val, item) => {
            return (
                <div>
                    <span>
                        <span>{item.rank}</span>{' '}
                        <span className={`${item.rankWoWChange < 0 ? styles.CollegeRankWoWChangeRed : styles.CollegeRankWoWChangeGreen}`}>
                            {item.rankWoWChange !== 0 && (item.rankWoWChange > 0 ? `+${item.rankWoWChange}` : item.rankWoWChange)}
                        </span>
                    </span>
                </div>
            );
        },
    },
    {
        title: 'Team',
        sortable: false,
        maxWidth: 25,
        key: 'clubName',
        rowClassName: `${styles.nameCol}`,
        custom: (val, item) => {
            const collegeName = item?.clubName || '';
            return (
                <div className={`${styles.CollegeName}`}>
                    <Img
                        src={`${'/v1/club/'}${item.profilePhotoUrl}`}
                        defaultimg={'/img/v2/icons/icon-avatar-college.svg'}
                        className={`${styles.displayLogo}`}
                    />
                    <Link className="link" to={`/colleges/${item.clubId}`}>{collegeName}</Link>
                </div>
            );
        },
    },
    {
        ...defaultDivisionColumn,
        key: 'divisionName',
        rowClassName: `${styles.divisionCol}`,
        custom: (val, item) => item?.divisionName || '',
    },
    {
        ...defaultConferenceColumn,
        key: 'conferenceName',
        rowClassName: `${styles.conferenceCol}`,
        custom: (val, item) => item?.conferenceName || '',
    },
    {
        ...defaultRecordColumn,
        title: 'W/L',
        key: 'record',
        rowClassName: `${styles.recordCol}`,
        custom: (val, item) => item?.record || '',
    },
    {
        ...power6Generic,
        key: 'power6',
        headerClassName: `${styles.psixHead}`,
        rowClassName: `${styles.psixCol}`,
        custom: (val, item) => (item?.power6 ? item.power6.toFixed(2) : 0),
    },
    {
        ...power6Generic,
        key: 'power6masked',
        headerClassName: `${styles.psixHead}`,
        rowClassName: `${styles.psixCol}`,
        custom: (val, item) => (item?.power6Masked ? item.power6Masked : 0),
    },
];
